<template>
  <div id="app">
    <div v-if="this.Language=='en'" style="font-family: Arial;">
      <Headeren @ZLchange="ZLchange" @JLchange="JLchange" :Language="Language"></Headeren> 
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <Footeren></Footeren>
    </div>
    <div v-else-if="this.Language=='jp'" style="font-family: Arial;">
      <Headerjp @ELchange="ELchange" @ZLchange="ZLchange" :Language="Language"></Headerjp> 
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <Footerjp></Footerjp>
    </div>
    <div v-else style="font-family: 微软雅黑;">
      <Header @ELchange="ELchange" @JLchange="JLchange" :Language="Language"></Header>
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <Footer></Footer>
    </div>
  </div>
</template>

<script>
// 导入头部
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Headeren from '@/components/Henderen'
import Footeren from '@/components/Footeren'
import Headerjp from '@/components/Headerjp'
import Footerjp from '@/components/Footerjp'
import $ from '@/common/js/jquery-1.11.0.min.js'
export default {
  data(){
    return{
      Language: 'en',
    }
  },
  mounted(){
// 小滚轮
$(document).ready(function () {
      var toggle = $('#ss_toggle')
      var menu = $('#ss_menu')
      var rot
      $('#ss_toggle').on('click', function () {
        rot = parseInt($(this).data('rot')) - 180
        menu.css('transform', 'rotate(' + rot + 'deg)')
        menu.css('webkitTransform', 'rotate(' + rot + 'deg)')
        if ((rot / 180) % 2 == 0) {
          toggle.parent().addClass('ss_active')
          toggle.addClass('close')
        } else {
          toggle.parent().removeClass('ss_active')
          toggle.removeClass('close')
        }
        $(this).data('rot', rot)
      })
      menu.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
        if ((rot / 180) % 2 == 0) {
          $('#ss_menu div i').addClass('ss_animate')
        } else {
          $('#ss_menu div i').removeClass('ss_animate')
        }
      })
    })

    // 全局内部滚动效果
    this.$nextTick(() => {
      setTimeout(() => {
        const id = this.$route.hash.slice(1)
        const el = document.getElementById(id)
        if (!el) {
          window.scrollTo(0, 0);
        }
        else{
          const elRect = el.getBoundingClientRect()
          const offsetX = elRect.left + window.scrollX
          // 响应式偏移量计算 
          const isMobile = window.innerWidth  <= 768;
          const offsetY = elRect.top  + window.scrollY  - (isMobile ? 55 : 85);

          window.scrollTo({
            left: offsetX,
            top: Math.max(0,  offsetY),
            behavior: 'smooth',
          })
        }
        
      }, 1000)
    })
  },
  created() {
    //切换语言
  const Language = localStorage.getItem('Language')
  if (Language) {
    this.Language = JSON.parse(Language)
  } else {
    this.Language = 'en'
  }
  window.addEventListener('beforeunload', () => {
    localStorage.setItem('Language', JSON.stringify(this.Language))
  })
  },
  watch: {
    Language(newVal) {
      localStorage.setItem('Language', JSON.stringify(newVal))
    }
  },
  
  components: {
    Footer,
    Headeren,
    Footeren,
    Header,
    Footerjp,
    Headerjp,
  },
  methods:{
    ELchange(){
      this.Language='en'
      this.$router.push('/homeen')
      location.reload()
    },
    ZLchange(){
      this.Language='zn'
      this.$router.push('/home')
      location.reload()
    },
    JLchange(){
      this.Language='jp'
      this.$router.push('/homejp')
      location.reload()
    }
  } 
}

</script>

<style lang="less" scoped>
html {
  scroll-padding-top: 100px;  
}
.fade-enter{
  visibility: hidden;
  opacity: 0;
}
.fade-leave-to{
  display: none;
}
.fade-enter-active,
.fade-leave-active{
  transition: opacity 3s ease;
}
.fade-enter-to,
.fade-leave{
  visibility: visible;
  opacity: 1;
}
.popup-icon {
  position: fixed;
  bottom: 10px;
  left: 15px;
  z-index: 300;
  display: inline-block;
  width: 50px;
  height: 50px;
}

.popup-icon button {
  background-color: transparent;
  outline: none;
  border: none;
}

.modal-btn img {
  width: 50px;
  height: 50px;
}
</style>
